import directives from './module';
import {Utils} from 'underscore-extensions';

class AutoplayVideo implements ng.IComponentController {

    private static readonly iOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

    readonly withWebm: boolean;
    readonly withRetina: boolean;
    readonly url: string;

    readonly videoUrl: string = this.$sce.trustAsResourceUrl(
        options.retina && this.withRetina ? this.url + '_2x' : this.url
    );

    constructor(private $rootScope: ng.IRootScopeService,
                private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $sce: ng.ISCEService) {
    }

    $onInit() {
        const video = <HTMLVideoElement>this.$element[0].querySelector('video');
        const safe  = (f: 'pause' | 'play') => video && _.isFunction(video[f]) && video[f]();
        this.$rootScope.$on(`onScreen:${this.url}`, () => safe('play'));
        this.$rootScope.$on(`notOnScreen:${this.url}`, () => safe('pause'));
        if (options.handHeld && !AutoplayVideo.iOS) {
            Utils.scopedEvent('touchstart', this.$scope, function videoStart() {
                safe('play');
                window.removeEventListener('touchstart', videoStart);
            });
        } else {
            safe('pause');
        }
    }

    $onDestroy() {
        _.isFunction(window.stop) && window.stop();

    }
}
directives.component('autoplayVideo', {
    bindings: {
        url: '@',
        width: '@',
        height: '@',
        withWebm: '<',
        withRetina: '<'
    },
    controller: AutoplayVideo,
    template: `<div>
                    <video width="{{::$ctrl.width}}" height="{{::$ctrl.height}}" 
                           preload autoplay muted loop playsinline webkit-playsinline>
                        <source ng-src="{{::$ctrl.videoUrl + '.webm'}}" type="video/webm" ng-if="::$ctrl.withWebm">
                        <source ng-src="{{::$ctrl.videoUrl + '.mp4'}}"  type="video/mp4">
                    </video>
                    <div id="{{::$ctrl.url}}" class="middle" is-on-screen></div>
               </div>`
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/AutoplayVideo.ts